export const BLANK_VIDEO_ID = -1;
